import {
  UpdateAttendanceBalanceCarryoverDocument,
  UpdateAttendanceBalanceCarryoverMutationVariables,
} from 'generated/resources/graphql'

import { useMutation } from 'modules/core/hooks/useMutation'

export const useUpdateAttendanceBalanceCarryover = () => {
  const [updateAttendanceBalanceCarryover, { loading }] = useMutation(
    UpdateAttendanceBalanceCarryoverDocument,
    {
      extractorFn: (data) => data.attendanceMutations.updateAttendanceBalanceCarryover,
    }
  )

  const updateBalanceCarryover = (variables: UpdateAttendanceBalanceCarryoverMutationVariables) => {
    return updateAttendanceBalanceCarryover({
      variables,
    })
  }

  return {
    loading,
    updateBalanceCarryover,
  }
}
